import Vue from 'vue';
import Component from 'vue-class-component';

import { sharedState } from './framework/state';
import { localizeVeeValidate } from '../i18n';
import { getProfile, putProfile } from './framework/client/profile';
import { logout } from './framework/service/authentication_service';
import { isToyotaFleetPortal } from './application/service/toyota_finance_finland.service';

import CustomerSelector from './application/components/manager/CustomerSelector.vue';

@Component({
    components: {
        CustomerSelector,
    },
})
export default class App extends Vue {
    public shared = sharedState;
    public local = {
        langs: ['fi', 'en'],
        hideNavigation: false,
        showToyotaFleetPortalLogo: false,
    };

    public async logout() {
        await logout();
    }

    public async changeLanguage(lang: string) {
        this.shared.mobileBurgerOpen = false;
        this.$i18n.locale = lang;
        localizeVeeValidate(lang);

        if (sharedState.authenticated) {
            const profile = await getProfile();
            await putProfile({ ...profile, locale: lang });
        }
    }

    // Functions
    public async mounted() {
        this.local.hideNavigation = getQueryVariable('hideNavigation') === 'true';
        console.log('hide navigation: ' + this.local.hideNavigation);

        if (isToyotaFleetPortal()) {
            // Add Toyota-specific styling or logic here
            document.body.classList.add('toyota-fleet-portal');
            this.local.showToyotaFleetPortalLogo = true;

            // Dynamically load Toyota Fleet Portal styles
            this.loadToyotaFleetPortalStyles();
        }
    }

    private loadToyotaFleetPortalStyles() {
        // Create a link element to load the Toyota theme init styles
        // const themeInitLink = document.createElement('link');
        // themeInitLink.rel = 'stylesheet';
        // themeInitLink.type = 'text/scss';
        // themeInitLink.href = 'toyota-fleet-portal-theme-init.scss';
        // document.head.appendChild(themeInitLink);

        // // Create a link element to load the Toyota theme styles
        // const themeStylesLink = document.createElement('link');
        // themeStylesLink.rel = 'stylesheet';
        // themeStylesLink.type = 'text/scss';
        // themeStylesLink.href = 'toyota-fleet-portal-theme-styles.scss';
        // document.head.appendChild(themeStylesLink);

        // Update theme color meta tag for Toyota Fleet Portal
        const themeColorMeta = document.querySelector('meta[name="theme-color"]');
        if (themeColorMeta) {
            themeColorMeta.setAttribute('content', '#000');
        }
    }
}

function getQueryVariable(variable: string): string | undefined {
    const query = window.location.search.substring(1);
    const vars = query.split('&');

    vars.forEach((queryVariable) => {
        const pair = queryVariable.split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    });

    console.log('Query variable %s not found', variable);
    return undefined;
}
